// Milestone 2 forensic engine action metadata (mirrors backend forensic_engines.ACTIONS)
export const ACTION_META = {
  ocr: { name: "Forensic OCR", engine: "Forensic OCR & Digitization" },
  handwriting: { name: "Handwriting & Forgery", engine: "Handwriting Analysis" },
  cipher: { name: "Cryptography", engine: "Cipher Analysis" },
  linguistic: { name: "Psych & Linguistic", engine: "Psychological & Linguistic Analysis" },
  image: { name: "Image Processing", engine: "Image Processing" },
};

// Milestone 4 — remaining Forensic Specialist library (mirrors backend specialist_engines.SPECIALISTS)
export const SPECIALIST_ACTIONS = [
  { key: "document_report_analysis", name: "Document & Report Analysis", discipline: "Textual" },
  { key: "translation_cultural", name: "Translation & Cultural Context", discipline: "Textual" },
  { key: "pattern_matching", name: "Pattern Matching (MO/Trends)", discipline: "Behavioral" },
  { key: "predictive_crime_mapping", name: "Predictive Crime Mapping", discipline: "Geographic" },
  { key: "case_linking", name: "Case Linking", discipline: "Geographic" },
  { key: "cci_grid", name: "Cross-Case Intelligence Grid", discipline: "Geographic" },
  { key: "case_simulation", name: "Case Simulation & Modeling", discipline: "Reasoning" },
  { key: "multiverse_deduction", name: "Multiverse Deduction", discipline: "Reasoning" },
  { key: "vehicle_logistics", name: "Vehicle & Logistics", discipline: "Geographic" },
  { key: "cyber_footprint", name: "Cyber / Digital Footprint", discipline: "Digital" },
  { key: "financial_forensic", name: "Financial Forensic", discipline: "Digital" },
  { key: "toxicology_medical", name: "Toxicology & Medical", discipline: "Biological" },
  { key: "dna_biological", name: "DNA & Biological Evidence", discipline: "Biological" },
  { key: "public_archive", name: "Public Archive / OSINT", discipline: "Digital" },
  { key: "audio_forensics", name: "Audio Forensics", discipline: "Visual" },
  { key: "emotion_deception", name: "Emotion & Deception Detection", discipline: "Visual" },
  { key: "ballistics_weapon", name: "Ballistics & Weapon Analysis", discipline: "Visual" },
  { key: "live_data_stream", name: "Live Data Stream", discipline: "Active" },
];
